// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    AutoAssign_Issue: 'Auto assign new risks to:',
    issue: 'Risk',
};
